<template>
  <div class="section-creation">
    <div class="section-title"></div>
    <div class="section-creation-content">
      <div class="creation-tab-list">
        <div
          class="creation-tab"
          v-for="(item, index) in creationList"
          :class="{
            active: index === activeTabIndex,
            locked: Date.now() < item.ts,
          }"
          :key="index"
          @click="handleTabChange(index)"
        >
          <div class="lock-icon" v-if="Date.now() < item.ts">
            <img
              src="https://imgheybox.max-c.com/oa/2025/01/21/7a8649f71de14691dfdb71d09b4b5ee6.png"
              alt=""
            />
          </div>
          <p>{{ item.label }}</p>
        </div>
      </div>
      <div class="creation-task-list">
        <div
          class="creation-task"
          v-for="task in creationList[activeTabIndex].tasks"
          :key="task.tag"
        >
          <div class="task-icon">
            <img :src="heygril[task.icon]" alt="" />
          </div>
          <div class="task-info">
            <div class="task-title">{{ task.tag }}</div>
            <div class="task-desc">{{ task.desc }}</div>
          </div>
          <div
            class="task-btn"
            @click="toPostLink(task.tag, activeTabIndex)"
          ></div>
        </div>
        <div class="creation-task-award">
          <div class="award-list">
            <div
              class="award-item"
              v-for="award in creationList[activeTabIndex].awards"
              :key="award"
            >
              <img :src="award" alt="" />
            </div>
          </div>
          <p class="award-desc">
            带以上任意话题发布10字以上且至少有一张图片的话题相关内容。活动结束后，盒妹将在符合标准的内容中，随机抽取用户送出新春好礼。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { executeProtocol, showMessage } from '_lib/utils';

export default {
  data() {
    return {
      heygril: [
        'https://imgheybox.max-c.com/oa/2025/01/21/dfbe47168a773ea044be53fe1df9f1e5.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/d8e75bb528ea89699660ec5ad4d94c47.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/261c6d814343fcd2b83398e17d0d3e9a.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/9c7b0cd6216c4d67c893f6cb2147ea33.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/0273976132886e444ffdc645d3ba7440.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/5ad1ab5089ecf18d521d256890475fb4.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/7754ba963d15accee3ee253d4117e3de.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/dfc7075795c19c6f53ad6a0b09c212da.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/ff39f0d8191256ac4e3c9abd8a471f90.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/bcf3d54117a966a0adba61b1ff158b09.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/5b93c7996832ecafd153c2821dff2e9a.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/6bcd6c9fc1abaf2bb2f6fd4e4ec4be65.png',
        'https://imgheybox.max-c.com/oa/2025/01/21/f251d9843fa1ba1c1adf7e20c1fa2c42.png',
      ],
      creationList: [
        {
          label: '小年',
          ts: 1737475200000,
          tasks: [
            {
              tag: '#年前最后一局',
              desc: '最后亿局，这把一定......',
              icon: 0,
            },
            {
              tag: '#寒假玩什么',
              desc: '不会只有我回村用流量玩吧',
              icon: 1,
            },
            {
              tag: '#我了个春运',
              desc: '兄弟你把我票挤掉了！',
              icon: 2,
            },
            {
              tag: '#年货已就位',
              desc: '全体目光向我家看齐',
              icon: 3,
            },
            {
              tag: '#有年味儿了嗷',
              desc: '看我今天在街上发现了什么！',
              icon: 4,
            },
          ],
          awards: [
            'https://imgheybox.max-c.com/oa/2025/01/21/c83706ddf17e01b167abfdab067fa92c.png',
            'https://imgheybox.max-c.com/oa/2025/01/21/87a1fd2e7930d79fdb7031d56ba6f5b4.png',
            'https://imgheybox.max-c.com/oa/2025/01/21/98793758fc201ab1250f94a1a2d423dd.png',
          ],
        },
        {
          label: '除夕',
          ts: 1737993600000,
          tasks: [
            {
              tag: '#赛博守岁',
              desc: '我要和我最好的游戏一起过年',
              icon: 5,
            },
            {
              tag: '#看看你的年夜饭',
              desc: '香！香！香！我吃吃吃吃吃吃',
              icon: 6,
            },
            {
              tag: '#盒你一起看春晚',
              desc: '那我问你，今年春晚好看吗？',
              icon: 7,
            },
            {
              tag: '#抢到大红包辣',
              desc: '鸿运齐天！',
              icon: 8,
            },
            {
              tag: '#请你看烟花',
              desc: '“烟火向星辰，所愿皆成真”',
              icon: 4,
            },
            {
              tag: '#团圆是最好的新年',
              desc: '这一刻，是今年最好的一刻',
              icon: 9,
            },
          ],
          awards: [
            'https://imgheybox.max-c.com/oa/2025/01/21/cb0e228a10dee048d3b953ba17bc9ab5.png',
            'https://imgheybox.max-c.com/oa/2025/01/21/97cb6b9bade084c192dc8912649212e2.png',
            'https://imgheybox.max-c.com/oa/2025/01/21/d41bacb71dabab771eb92e0bc12c70b5.png',
          ],
        },
        {
          label: '初一',
          ts: 1738080000000,
          // ts: 1737433952694,
          tasks: [
            {
              tag: '#新年新皮肤',
              desc: '游戏里也要穿新衣服',
              icon: 7,
            },
            {
              tag: '#给游戏搭子拜个年',
              desc: '新的一年还请多多指教！',
              icon: 3,
            },
            {
              tag: '#合家欢游戏推荐',
              desc: '我奶玩了都说好',
              icon: 10,
            },
            {
              tag: '#新春开门红',
              desc: '赢！中！欧！爽！发！',
              icon: 8,
            },
            {
              tag: '#蛇年大吉',
              desc: '祝大家蛇年大吉，巳巳如意',
              icon: 5,
            },
            {
              tag: '#寒假出行计划',
              desc: '这个寒假去哪玩了？',
              icon: 11,
            },
          ],
          awards: [
            'https://imgheybox.max-c.com/oa/2025/01/21/e2aee2a6d1ab823ce91647cef9ef850a.png',
            'https://imgheybox.max-c.com/oa/2025/01/21/f3563ac10d31d2a826b24e70dc5cb877.png',
            'https://imgheybox.max-c.com/oa/2025/01/21/de6ab48bb4e40988c746c769ea9261db.png',
          ],
        },
        {
          label: '初五',
          ts: 1738425600000,
          // ts: 1737433952694,
          tasks: [
            {
              tag: '#顺风顺水迎财神',
              desc: '喜迎财神 多财多福',
              icon: 5,
            },
            {
              tag: '#我妈让我赶紧开学',
              desc: '妈，刚放假的时候你可不是这么说的',
              icon: 6,
            },
            {
              tag: '#贺岁档电影',
              desc: '今年你有推荐吗？',
              icon: 12,
            },
            {
              tag: '#我们是最好的朋友',
              desc: '铁铁，下次放假还跟你玩',
              icon: 3,
            },
          ],
          awards: [
            'https://imgheybox.max-c.com/oa/2025/01/21/999f926c8d4e70a274378925e9706b0e.png',
            'https://imgheybox.max-c.com/oa/2025/02/02/365442107fc448f1d3dec5cab74bfdc0.png',
            'https://imgheybox.max-c.com/oa/2025/02/02/0ae29370df18880c27108208a91b7c26.png',
          ],
        },
      ],
      activeTabIndex: -1,
    };
  },
  created() {
    this.activeTabIndex =
      this.findLastIndex(this.creationList, (item) => Date.now() >= item.ts) ||
      0;
  },
  methods: {
    toPostLink(tag, index) {
      const now = Date.now();
      let protocol = {};
      if (
        now < this.creationList[index].ts + 8 * 60 * 60 * 1000 ||
        (index === 0 && now < 1737720000000)
      ) {
        protocol = {
          protocol_type: 'openRouterPath',
          path: '/bbs/post',
          params: {
            post_type: 4, // 1: 发帖 2: 投稿 3: 动态 4: 图文 5: 视频
            tags: [tag.replace('#', '')],
          },
        };
      } else {
        protocol = {
          protocol_type: 'openBBSTag',
          tag: tag.replace('#', ''),
        };
      }
      executeProtocol(protocol);
    },
    handleTabChange(index) {
      const now = Date.now();
      if (now < this.creationList[index].ts) {
        showMessage('failed', '暂未到解锁时间');
        return;
      }
      this.activeTabIndex = index;
    },
    findLastIndex(array, cb) {
      if (!Array.isArray(array)) {
        return undefined;
      }
      if (array.length === 0) {
        return undefined;
      }
      for (let i = array.length - 1; i >= 0; i--) {
        const item = array[i];
        if (cb.call(null, item, i, array)) {
          return i;
        }
      }
      return undefined;
    },
  },
};
</script>

<style lang="less">
.section-creation {
  width: 100%;
  padding: 0 12px;
  margin-top: 30px;
  .section-title {
    width: 100%;
    padding-top: calc(57 / 351 * 100%);
    background: center / auto 100%
      url(https://imgheybox.max-c.com/oa/2025/01/21/4b7777d19d2f98207f7a7942b7f482c4.png)
      no-repeat;
  }
  .section-creation-content {
    background: center top / 100% 80px
      linear-gradient(0deg, #ffffff 0%, #ffffe2 100%) no-repeat #ffffff;
    border-radius: 12px;
    padding: 15px 12px 14px;
    margin-top: 6px;
    .creation-tab-list {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0 3px;
      .creation-tab {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 0;
        flex: 1;
        height: 31px;
        background: #ffe3dc;
        border-radius: 8px;
        &:not(:last-child) {
          margin-right: 11px;
        }
        .lock-icon {
          width: 18px;
          height: 18px;
          margin-right: 1px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        > p {
          color: #ed234c;
          font-size: 15px;
          line-height: 21px;
        }
        &.locked {
          > p {
            color: #ed234c80;
          }
        }
        &.active {
          background: linear-gradient(102.73deg, #ff8385 4.33%, #ed234c 92.88%);
          > p {
            color: #ffffff;
          }
          &:after {
            content: '';
            display: block;
            position: absolute;
            left: 50%;
            bottom: -5px;
            width: 20px;
            height: 5px;
            transform: translateX(-50%);
            background: center / 100% 100%
              url(https://imgheybox.max-c.com/oa/2025/01/21/5aba75dcae6ced510ac83de1c0f1f554.png)
              no-repeat;
          }
        }
      }
    }
    .creation-task-list {
      width: 100%;
      margin-top: 17px;
      .creation-task {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        height: 62px;
        &:not(:first-child) {
          height: 72px;
          padding-top: 10px;
          &:after {
            content: '';
            display: block;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 1px;
            background: #ffe2e3;
            transform: scaleY(0.5);
            transform-origin: left top;
          }
        }
        .task-icon {
          width: 62px;
          height: 62px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .task-info {
          margin-left: 5px;
          .task-title {
            color: #cf2d53;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
          }
          .task-desc {
            color: #956e6e;
            font-size: 11px;
            line-height: 15px;
            margin-top: 3px;
          }
        }
        .task-btn {
          width: 93px;
          height: 35px;
          background: center / 100% 100%
            url(https://imgheybox.max-c.com/oa/2025/01/21/57fee9a548815d85971e9585486c432a.png)
            no-repeat;
          margin-left: auto;
        }
      }
      .creation-task-award {
        padding: 11px;
        margin-top: 14px;
        border-radius: 10px;
        background: linear-gradient(
          180deg,
          rgba(255, 245, 236, 0.5) 0%,
          rgba(255, 243, 243, 0.5) 95.19%
        );
        .award-list {
          display: flex;
          align-items: center;
          .award-item {
            position: relative;
            width: calc((100% - 20px) / 3);
            flex: 1;
            padding-top: calc((100% - 20px) / 3);
            border-radius: 8px;
            background: #ffdfdf;
            overflow: hidden;
            &:not(:last-child) {
              margin-right: 10px;
            }
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
            }
          }
        }
        .award-desc {
          color: #956e6e;
          font-size: 12px;
          line-height: 21px;
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
